import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { LANGUAGE_LIST } from "../shared/language.constants";
import { StateService } from "../services/state.service";
import { DomainNavigationService } from "../services/domain-navigation.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  signUp: boolean = false;
  domainType: string = "";

  constructor(
    private router: Router,
    private stateService: StateService,
    private domainNavigationService: DomainNavigationService,
    private translate: TranslateService
  ) {
    this.domainType = this.stateService.checkAppConfig();
  }

  ngOnInit(): void {
    this.applyStoredLanguage();
  }

  // Login has no language switcher, so honour the language picked on the landing page
  private applyStoredLanguage() {
    try {
      const stored = JSON.parse(localStorage.getItem("appLanguage") || "null");
      const code = typeof stored === "string" ? stored : stored?.language;
      if (LANGUAGE_LIST.some((item) => item.language === code)) {
        this.translate.use(code);
      }
    } catch (_error) {}
  }

  login() {
    // Get the domain-specific login URL with appropriate redirect
    const loginUrl = this.getLoginUrlWithRedirect();
    window.location.replace(loginUrl);
  }

  private getLoginUrlWithRedirect(): string {
    const baseLoginUrl = this.stateService.apiList.user.login;
    const redirectUrl = this.domainNavigationService.getLoginRedirectUrl();

    // Append redirect parameter to login URL
    const separator = baseLoginUrl.includes("?") ? "&" : "?";
    return `${baseLoginUrl}${separator}redirect=${encodeURIComponent(redirectUrl)}`;
  }

  userBoarding() {
    this.signUp = !this.signUp;
  }
}
